
import Vue from "vue";
import { initContainer } from "../";
import { Modal } from "../types";

export default Vue.extend({
  data() {
    return {
      modals: [] as Modal[],
    };
  },
  mounted() {
    // this makes the `$modal` plugin work
    initContainer(this);
  },
});
